// Imagem de og:image/twitter:image quando a página não tem uma própria.
// Provisória (a mesma que a home publica hoje): trocar pela arte definitiva aqui.
export const IMAGEM_COMPARTILHAMENTO_PADRAO =
  "https://api.belladasemana.com.br/storage/fixed-thumb/thumb_1683816883.jpg";

const ORIGEM_STORAGE = "https://api.belladasemana.com.br";

/**
 * Devolve o primeiro candidato que sirva de og:image: URL absoluta http(s) que
 * não seja o favicon. Caminho `/storage/...` é resolvido na origem da API;
 * outros relativos são descartados. Sem candidato válido, devolve o padrão.
 */
export function shareImage(...candidatos: unknown[]): string {
  for (const candidato of candidatos) {
    if (typeof candidato !== "string") continue;
    let url = candidato.trim();
    if (url.startsWith("/storage/")) url = ORIGEM_STORAGE + url;
    if (!/^https?:\/\/[^/\s]+/i.test(url)) continue;
    if (/\/favicon\.ico(?:[?#]|$)/i.test(url)) continue;
    return url;
  }
  return IMAGEM_COMPARTILHAMENTO_PADRAO;
}
